import axios from 'axios'
import store from '../store/index'
import router from '../router/index'
import { Message } from 'element-ui';
axios.defaults.baseURL = '/_'
axios.interceptors.request.use(config => {
  if (store.getters.getToken) {
    config.headers.common['Authorization'] = 'Bearer ' + store.getters.getToken
  } else {
    router.push({path: '/login'})
  }
  return config
})

axios.interceptors.response.use(res => {
  // console.log(res.headers)
  if (res.headers.token) {
    store.dispatch('changeToken', res.headers.token)
  }
  if (res.data) {
    if (res.data.code === 1 || res.data.code === 4 || res.data.code === 10 ||
      res.data.code === 5 || res.data.code === 6 ||
      res.data.code === 7 || res.data.code === 9 || res.data.code === 8 ||
      res.data.code === 2001 || res.data.code === 20002 || res.data.code === 20003
      || res.data.code === 401 || res.data.code === 10001) {
      router.push({path: '/login'})
    }else if (res.data.code === 10000 || res.data.code === 403 || res.data.code === 10002 ) {
      Message.error(res.data.message)
    }
  }
  return res
})



// WEBPACK FOOTER //
// ./src/api/index.js